export enum UserRole {
  PARTNER = "PARTNER",
  MARKETING = "MARKETING",
  ASSISTANT = "ASSISTANT",
  ADMIN = "ADMIN",
  USER = "USER"
}
